<template>
  <div class="page-card-wrapper no-patient-card">
    <EditPatient ref="editPatient" @saveSuccess="saveSuccess" />
    <div class="page-card-title">{{ $t('text.patient').toUpperCase() }}</div>
    <div class="page-card-content v-h-center">
      <el-empty :description="$t('text.there_are_no_patient_to_manage')">
        <el-button class="common-btn mt-10" @click="openDialog()">{{
          $t('text.add_patient')
        }}</el-button>
      </el-empty>
    </div>
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
export default {
  components: {
    EditPatient
  },
  methods: {
    openDialog() {
      this.$refs.editPatient.openDialog()
    },
    saveSuccess() {
      this.$emit('saveSuccess')
    }
  }
}
</script>
